import React, { useEffect } from 'react';
import { LogoUnderline } from './LetsCareersLogo';
import './SplashScreen.css';

export default function SplashScreen({ onDone }) {
  useEffect(() => {
    const t = setTimeout(onDone, 2600);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <div className="splash">
      <div className="splash__logo">
        <span className="splash__lets">lets</span>
        <span className="splash__careers">
          careers
          <LogoUnderline className="splash__underline" />
        </span>
      </div>
    </div>
  );
}
